import { Button, Modal } from "antd";
import { useMutation, useQueryClient } from "react-query";
import { showErrorToast, showSuccessToast } from "../../utils/toast";
import { deleteRate } from "../../api/rate";


const DeleteRateModal = ({
  open = false,
  setOpen,
  data,
  type = "giftcard",
}) => {
  const queryClient = useQueryClient();

  const mutation = useMutation(deleteRate, {
    onSuccess: () => {
      showSuccessToast("Rate deleted successfully");
      queryClient.invalidateQueries(type);
      setOpen(false);
    },
    onError: (e) => {
      showErrorToast(e.message);
    }
  });

  return (
    <Modal
      title={
        type === "giftcard"
          ? "Delete Gift Card"
          : type === "shipping"
          ? "Delete Shipping Rate"
          : type === "sell-giftcard"
          ? "Delete Sell Gift Card"
          : "Delete Crypto rate"
      }
      open={open}
      footer={null}
      onCancel={() => setOpen(false)}
    >
      <div className="flex flex-col justify-center items-center">
        <p>Are you sure you want to delete {data?.name}{" "}(with range {data?.range?.min}-{data?.range?.max})?</p>
        <div className="flex justify-center items-center gap-5 mt-10 w-full">
          <Button
            className="bg-red-700 text-white rounded-[5px] font-bold text-[15px] w-full"
            onClick={() => mutation.mutate({ id: data._id })}
            loading={mutation.isLoading}
          >
            Delete
          </Button>

          <Button
            className="bg-[#fdfdfd] text-black rounded-[5px] font-bold text-[15px] w-full"
            htmlType="button"
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteRateModal;
